module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/vi/2-9332f86b519d9c1f51d743bce6ef87c1.jpg";